import React from 'react';
import './GranularData.css';

// Import the new image
import dataImage from '../../assets/images/granular-data.jpg';

const GranularData = () => {
  return (
    <section className="granular-data-section">
      <div className="granular-data-container">
        {/* Left Column: Text Content */}
        <div className="granular-text-col">
          <h2>Authentic, extensive & granular data you can trust</h2>
          <p>
            CRISHI offers one of the most comprehensive and reliable commodity datasets in India. We cover prices, production, trade, inventory, and movement across various agricultural commodities — all validated by industry participants.
          </p>
          <p>
            With over 20 years of structured historical data, you can go beyond tracking and start spotting long-term trends and turning points with clarity.
          </p>
        </div>

        {/* Right Column: Image */}
        <div className="granular-image-col">
          <img src={dataImage} alt="Granular data dashboard on a laptop" />
        </div>
      </div>
    </section>
  );
};

export default GranularData;